<section
  [ngClass]="{
    'centered-with-padding py-14': !displayedInPopin(),
    'mx-auto max-w-[900px] py-10': displayedInPopin(),
  }">
  @if (data.title; as title) {
    <app-title [title]="title" size="h1" />
  }
  @if (data.reviewStats; as reviewStats) {
    <div class="-mx-5 grid grid-cols-1 gap-y-10 py-9 desk:mx-auto desk:grid-cols-12">
      <div class="relative col-span-5 flex items-center justify-center">
        <app-review-badge [reviewStats]="reviewStats" [forceMobileDisplay]="true" />
      </div>
      <div class="col-span-7 px-5 desk:pl-10">
        <app-rating-distribution [storeUuid]="data.storeId ?? null" />
      </div>
    </div>
  }

  @if (data.reviewStats; as reviewStats) {
    <p
      [innerHtml]="
        (isStorePage()
          ? 'COMPONENT.AVIS-GOOGLE-DETAILS.AVERAGE_RATING_DISCLAIMER_STORE'
          : 'COMPONENT.AVIS-GOOGLE-DETAILS.AVERAGE_RATING_DISCLAIMER'
        ) | translate: { nbReviews: reviewStats.totalReviews }
      "
      class="py-5"></p>
  }
  <app-review-list [loadMoreMode]="loadMoreReviewsMode()" [storeUuid]="data.storeId" />
</section>
